import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { safeContent } from '../../utils';

import { connect } from 'react-redux';
import { getAllCategories } from '../../actions/categoryActions';

function CategoryBanner( props ) {

    let categories = props.categories;

    return (
        <div className="cat-banner row no-gutters" style={{'height': '100%'}}>



            {
                /*
                <div className="cat-banner-list col-sm-6 d-xl-none d-xxl-flex">
                    <div className="banner-list-content">

                        {categories[props.index] !== undefined && (
                            <h2><Link to="#">{categories[props.index].nameFr}</Link></h2>
                        )}

                        {categories[props.index] !== undefined && (
                            <ul>
                                {
                                    categories[props.index].children.map((item, index) =>
                                        <li key={index}>
                                            <Link
                                                to={`${process.env.REACT_APP_PUBLIC_URL}/shop/bycategory/${item.slug}`}>{item.nameFr}</Link>
                                        </li>
                                    )
                                }
                                <li className="list-all-link"><Link to="/shop/sidebar/list">Voir Autre Catégories</Link>
                                </li>
                            </ul>
                        )}

                    </div>
                </div>

                 */
            }



            {categories[props.index] !== undefined && (

                                <div className="col-md-12 col-sm-12" style={{height:300, position:'relative'}}>
                                    <div className="banner banner-overlay">
                                        <Link to={`${process.env.REACT_APP_PUBLIC_URL}/shop/bycategory/${categories[props.index].slug}`} style={{height: 300}}>

                                            <div className="lazy-overlay bg-dark"></div>

                                            <LazyLoadImage
                                                src={ `${process.env.REACT_APP_API_URL}/uploads/categories/${categories[props.index].fileName}` }
                                                //src={ "/assets/images/home/banners/banner-5.jpg" }
                                                alt="Banner desc"
                                                width={ 100 }
                                                //height={ 390 }
                                                height="100%"
                                                effect="blur"
                                            />
                                        </Link>

                                        <div className="banner-content">
                                            {/*<h4 className="banner-subtitle text-white"><Link to="#">{ categories[props.index].nameFr }</Link></h4>*/}
                                            <h3 className="banner-title text-white" style={{lineHeight:'50px'}}><Link to={ `${process.env.REACT_APP_PUBLIC_URL}/shop/bycategory/${categories[props.index].slug}` } dangerouslySetInnerHTML={ safeContent( categories[props.index].nameFr ) } ></Link></h3>
                                            <Link to={ `${process.env.REACT_APP_PUBLIC_URL}/shop/bycategory/${categories[props.index].slug}` } className="banner-link">ACHETEZ  <i className="icon-long-arrow-right"></i></Link>
                                        </div>
                                    </div>
                                </div>




            )}


        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        categories: state.categories.categories ? state.categories.categories : [],
    }
}

export default  connect(mapStateToProps, { getAllCategories } ) (CategoryBanner);